import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from './components/Navbar';

import './css/App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from "./components/Layout";
import Head from "./components/Head";
import Photos from "./pages/Photos";
import About from "./pages/About";
import Contact from "./components/Contact";
import Service from "./components/Service";




function App() {
  return (
    <BrowserRouter>
      <Head />
      <Navbar />
      <Routes>
        <Route path="*" element={<Layout />} />
        <Route path="/Photos" element={<Photos />} />
        <Route path="/About" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Service" element={<Service />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;


